/**
 * Make an array of <Select> options where the value and the label are the same
 */
export function makeSelectOptions(
  values: Array<string | number>,
  getLabel?: (value: string | number) => string
) {
  return values.map((value) => ({ label: getLabel ? getLabel(value) : value.toString(), value }));
}
